import { coerce, create, defaulted, Describe, nullable, number, optional, string, type } from 'superstruct';

export const IconLibraryConfigValidator: Describe<Required<IconLibraryConfig>> = defaulted(
  type({
    defaultSvgBackgroundColor: optional(nullable(string())),
    defaultSvgFillColor: optional(nullable(string())),
    listItemStyles: optional(nullable(string())),
    pngOutputSizes: optional(nullable(coerce(string(), number(), val => `${val}`))),
    realm: optional(nullable(string())),
    searchCategories: optional(nullable(string())),
    svgBackgroundColors: optional(nullable(string())),
    svgFillColors: optional(nullable(string())),
  }),
  {
    defaultSvgBackgroundColor: '',
    defaultSvgFillColor: '',
    listItemStyles: '',
    pngOutputSizes: '',
    realm: 'icon_library',
    searchCategories: '',
    svgBackgroundColors: '',
    svgFillColors: '',
  },
);

export default (rawConfig: string): IconLibraryConfig => {
  let config: Partial<IconLibraryConfig>;
  try {
    config = JSON.parse(rawConfig);
  } catch (_error) {
    config = {};
  }

  return create(config, IconLibraryConfigValidator);
};
